import { Link } from 'react-router-dom';
import { IconBox } from '../components/Icons.jsx';

function About() {
  return (
    <div className="about-page">
      <section className="hero-section">
        <div className="hero-content">
          <p className="hero-eyebrow">About The Hosting Hive</p>
          <h1 className="hero-title">Technology Partners for Business Owners</h1>
          <p className="hero-subtitle">
            We help businesses run reliable websites and applications with managed hosting, proactive care,
            and development expertise — so you can focus on customers, not server logs.
          </p>
        </div>
      </section>

      <section className="services-section">
        <div className="services-container about-content">
          <div className="about-grid">
            <div className="about-text">
              <h3>Our Mission</h3>
              <p>
                The Hosting Hive was built for business owners who need their digital presence to be dependable,
                secure, and professionally maintained without hiring a full in-house team. We combine hosting,
                development expertise, and hands-on support into one accountable partner.
              </p>
              <h3>What Sets Us Apart</h3>
              <ul className="about-features">
                <li>Managed hosting with security and backups included</li>
                <li>Direct access to specialists — not outsourced support tiers</li>
                <li>Transparent pricing with clear scope and deliverables</li>
                <li>Long-term partnerships focused on uptime and performance</li>
                <li>Custom development when your business needs more than a template</li>
              </ul>
            </div>
            <div className="about-stats">
              <div className="stat-item">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Uptime target on managed hosting</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">1 Day</div>
                <div className="stat-label">Typical response time for inquiries</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">30 Min</div>
                <div className="stat-label">Free initial consultation</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100%</div>
                <div className="stat-label">Focus on business web solutions</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-section">
        <div className="features-container">
          <h2 className="section-title">Our Values</h2>
          <div className="features-grid">
            <div className="feature-item">
              <IconBox name="security" />
              <div className="feature-content">
                <h4>Reliability</h4>
                <p>We treat uptime, security, and performance as non-negotiable.</p>
              </div>
            </div>
            <div className="feature-item">
              <IconBox name="support" />
              <div className="feature-content">
                <h4>Accountability</h4>
                <p>Clear timelines, honest recommendations, and follow-through.</p>
              </div>
            </div>
            <div className="feature-item">
              <IconBox name="growth" />
              <div className="feature-content">
                <h4>Clarity</h4>
                <p>No jargon-heavy proposals or hidden fees.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Let&apos;s Talk About Your Project</h2>
          <p>Schedule a free consultation to discuss your goals and next steps.</p>
          <Link to="/contact" className="cta-button">Book a Free Consultation</Link>
        </div>
      </section>
    </div>
  );
}

export default About;
